import { render } from "./benefits-calculator.vue?vue&type=template&id=5d350f76"
import script from "./benefits-calculator.vue?vue&type=script&lang=js"
export * from "./benefits-calculator.vue?vue&type=script&lang=js"

import "./benefits-calculator.vue?vue&type=style&index=0&id=5d350f76&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__